import { render, staticRenderFns } from "./index.vue?vue&type=template&id=fb176ae6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=fb176ae6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb176ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb176ae6')) {
      api.createRecord('fb176ae6', component.options)
    } else {
      api.reload('fb176ae6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=fb176ae6&scoped=true", function () {
      api.rerender('fb176ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/dashboard/index.vue"
export default component.exports